import {Alert, Button, Card, CardContent, Grid, IconButton, Skeleton, Stack, Tooltip, Typography} from "@mui/material";
import {fileFormatter} from "../../utils/formatters/fileFormatter";
import SyncIcon from "@mui/icons-material/Sync";
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import React, {useContext, useEffect, useState} from "react";
import {DataGrid, esES} from "@mui/x-data-grid";
import {FileBaseFields, SolicitationFileViewDTO} from "../../types/solicitation/solicitationFile";
import {CompanyContext, CompanyContextValue} from "../solicitation-new/context/companyContext";
import {HttpClientFile} from "../../http/client/httpClientFile";
import {EntityWithIdFields} from "../../types/baseEntities";
import {HttpFiles} from "../../http/files/httpFiles";
import {DownloadIconButton, SearchIconButton} from "../../components/buttons/Buttons";
import DialogPreviewFile from "../../components/dialog/DialogPreviewFile";


const DocumentationPage = () => {
    const [viewAsCards, setViewAsCards] = useState<boolean>(false)
    const [pageSize, setPageSize] = useState<number>(10)
    const [currentFiles, setCurrentFiles] = useState<SolicitationFileViewDTO[]>()
    const [loading, setLoading] = useState<boolean>(false)
    const [fileName, setFileName] = useState<string>()
    const [fileBlob, setFileBlob] = useState<any>()
    const [openPreview, setOpenPreview] = useState<boolean>(false)
    const {clientId} = useContext<CompanyContextValue>(CompanyContext)
    
    
    const loadFiles = () => {
        setLoading(true)
        HttpClientFile.getSolicitationsFiles(clientId).then((r) => {
            setCurrentFiles(r)
        }).finally(() => setLoading(false))
    }
    
    useEffect(() => {
        loadFiles()
    }, [clientId])
    
    const onDownloadFile = (file: SolicitationFileViewDTO) => {
        HttpFiles.download(file[EntityWithIdFields.Id])
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));

                const link = document.createElement('a');
                link.href = downloadUrl;

                link.setAttribute('download', file.descArchivo);

                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    }
    
    /*
    const onDeleteFile = () => {
        if(deleteFile) {
            setLoadingDelete(true)
            HttpFiles.delete(deleteFile[EntityWithIdFields.Id]).then(() => {
                snackbarSuccess('El archivo se eliminó correctamente')
                loadFiles()
                setLoadingDelete(false)
            })
        }
    }
     */

    const onPreviewFile = (file: SolicitationFileViewDTO) => {
        setFileName(file[FileBaseFields.FileDesc])
        setLoading(true)

        HttpFiles.download(file[EntityWithIdFields.Id]).then((data) => {
            setFileBlob(data)
            setLoading(false)
            setOpenPreview(true)
        })
    }

    const onClosePreview = () => {
        setFileBlob(undefined)
        setOpenPreview(false)
    }

    const cols = [
        {
            flex: 0.05,
            field: 'icon',
            minWidth: 80,
            headerName: '',
            renderCell: (params: any) => (
                fileFormatter.getIconByFileName(params.row[FileBaseFields.FileDesc], {fontSize: 'large'})
            ),
            id: 1
        },
        {
            flex: 0.5,
            minWidth: 170,
            field: 'descArchivo',
            headerName: 'Archivo',
            id: 2
        },
        {
            flex: 0.3,
            minWidth: 170,
            field: 'descArchivoTipo',
            headerName: 'Tipo',
            id: 3
        },
        {
            flex: 0.15,
            minWidth: 170,
            field: 'actions',
            headerName: 'Acciones',
            renderCell: (params: any) => (
                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                   <DownloadIconButton onClick={() => {onDownloadFile(params.row)}} tooltipTitle={'Descargar'} />
                   <SearchIconButton onClick={() => {onPreviewFile(params.row)}} tooltipTitle={'Previsualizar'} />
                    {
                        
                        /*
                        
                        <Button startIcon={<DeleteIcon fontSize={'small'}/>} size={'small'} color={'error'} 
                                onClick={() => {
                                    setDeleteFile(params.row)
                                    setOpenDelete(true)
                                }}>Eliminar</Button>
                         */
                    }
                </Stack>
            ),
            id: 4
        },
    ]
    
    return (
        <Stack spacing={2}>
            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                <Typography variant={'h5'}>Documentación</Typography>
                <Stack spacing={2} alignItems={'center'} direction={'row'}>
                    <Tooltip title={'Mostrar como lista'}>
                        <IconButton onClick={() => setViewAsCards(false)}>
                            <ViewListIcon fontSize='large' sx={{
                                color: viewAsCards ? 'primary' : 'black',
                                backgroundColor: viewAsCards ? 'primary' : 'white',
                                borderRadius: '30px',
                                p: 0.75
                            }}/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Mostrar como cartas'}>
                        <IconButton onClick={() => setViewAsCards(true)}>
                            <ViewModuleIcon fontSize='large' sx={{
                                color: !viewAsCards ? 'primary' : 'black',
                                backgroundColor: !viewAsCards ? 'primary' : 'white',
                                borderRadius: '30px',
                                p: 0.75
                            }}/>
                        </IconButton>
                    </Tooltip>
    
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<SyncIcon/>}
                    >
                        Recargar
                    </Button>
                </Stack>
            </Stack>
            <Card>
                <CardContent>
                    <Grid container spacing={2}>
                        {!currentFiles ? 
                            loading ? Array.from({length: 8}).map((d, idx) => <Grid item xs={12} key={idx}><Skeleton height={30}/></Grid>)
                                :
                                <Grid item xs={12}><Alert severity={'info'}>No hay documentación cargada aún</Alert></Grid>
                            :
                            currentFiles.length === 0 ?
                                <Grid item xs={12}><Alert severity={'info'}>No hay documentación cargada aún</Alert></Grid>
                                :
                                viewAsCards ?
                                    currentFiles.map((card, idx) => (
                                        <Grid item md={3} key={idx}>
                                            <Card sx={{border: '1px solid grey', borderRadius: '8px'}}>
                                                <CardContent>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>
                                                            <Typography>{card[FileBaseFields.FileDesc]}</Typography>
                                                        </Grid>
                                                        <Grid item md={3} xs={6} mt={1}>
                                                            {fileFormatter.getIconByFileName(card[FileBaseFields.FileDesc], {fontSize: 'large'})}
                                                        </Grid>
                                                        <Grid item md={9} xs={6}>
                                                            <Stack spacing={1}>
                                                                <Typography fontWeight={600} textAlign={'end'}>
                                                                    {card[FileBaseFields.FileTypeDesc]}
                                                                </Typography>
                                                                <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent={'end'}>
                                                                        <DownloadIconButton onClick={() => {onDownloadFile(card)}} tooltipTitle={'Descargar'} />
                                                                        <SearchIconButton onClick={() => {onPreviewFile(card)}} tooltipTitle={'Previsualizar'} />{
                                                                        
                                                                        /*
                                                                        
                                                                            <Button startIcon={<DeleteIcon fontSize={'small'}/>} size={'small'} color={'error'} onClick={() => {
                                                                                setDeleteFile(card)
                                                                                setOpenDelete(true)
                                                                            }}>Eliminar</Button>
                                                                         */
                                                                    }
                                                                </Stack>
                                                            </Stack>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))
                                    :
                                    <DataGrid columns={cols}
                                              rows={currentFiles}
                                              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                                              autoHeight
                                              rowsPerPageOptions={[5, 10, 25]}
                                              pageSize={pageSize}
                                              onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                                    />
                        }
                    </Grid>
                </CardContent>
                {
                    fileBlob && fileName &&
                    <DialogPreviewFile open={openPreview}
                                       onClose={onClosePreview}
                                       fileBlob={fileBlob}
                                       fileName={fileName}
                    />
                }
                {/*
                    {loadingDelete && <LoaderBlockUI/>}
                    deleteFile &&
                    <DeleteDialog open={openDelete}
                                  onClose={() => {setOpenDelete(false)}}
                                  onDelete={onDeleteFile}
                                  title={'Eliminar archivo'}
                                  description={`¿Está seguro de querer eliminar el archivo ${deleteFile[FileBaseFields.FileDesc]}?`}
                    />
                    */
                }
            </Card>
        </Stack>
    )
}


export default DocumentationPage